<template>
  <div class="relative flex items-center" role="tablist">
    <div ref="container" class="relative flex items-center">
      <slot></slot>
    </div>
    <span
      ref="slider"
      class="bg-yellow absolute bottom-0 left-0 h-0.5 w-0 transition-all"
      :style="{ left: `${left}px`, width: `${width}px` }"
    ></span>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from "vue";
import { useElementVisibility } from "@vueuse/core";

const slider = ref();
const left = ref(0);
const width = ref(0);
const container = ref();
const props = defineProps(["active"]);
const targetIsVisible = useElementVisibility(slider);

const syncTabAttrs = () => {
  [...(container.value?.children || [])].forEach((el, index) => {
    el.setAttribute("role", "tab");
    el.setAttribute("aria-selected", String(index === props.active));
  });
};

const updateWidth = () => {
  if (!container.value || !container.value.children?.length || !targetIsVisible.value) return;
  const offsetX = container.value.children[0].getBoundingClientRect().left;
  const elm = container.value.children?.[props.active].getBoundingClientRect();
  left.value = elm.left - offsetX;
  width.value = elm.width;
};
onMounted(syncTabAttrs);
watch(targetIsVisible, () => setTimeout(updateWidth, 330), { flush: "post" });
watch(
  () => props.active,
  () => (nextTick(updateWidth), syncTabAttrs()),
  { flush: "post" },
);
</script>
